import { useEffect, useState } from "react";
import gateway from "../../api"
import axios from "axios"

export default function HeroSlider() {
    const [mainBanner, setMainBanner] = useState(null)


    const fetchMainBanner = () => {

        axios
            .get(`${gateway()}/api/business-info/mainBanner/`)
            .then(res => {

                setMainBanner(res.data)
            })
            .catch(err => { console.error("main banner info error : ", err); });
    };

    useEffect(() => {
        fetchMainBanner()
    }, [])
    return <>
        <div className="h-screen bg-blend-darken relative bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${gateway()}${mainBanner?.mainBanner})` }}>
            <div className="flex flex-col px-4 lg:px-0 bg-black/30 w-full h-screen top-0 right-0 text-[33px] lg:text-[40px] text-white pt-28 lg:pt-32 font-bold text-right lg:pr-14">
                <h1>   {mainBanner?.mainBannerText} </h1>
                <div className="lg:w-1/3 text-justify text-sm md:text-md mt-3 lg:pr-3 font-normal leading-7" dir="rtl">
                    {mainBanner?.mainBannerDesc}
                </div>
                {mainBanner?.mainBannerShowCta && <div className="w-full flex justify-end items-end flex-1 pb-5 lg:pb-12 lg:pl-12">
                    <a href={`${mainBanner?.mainBannerCtaLink}`}>
                        <button className="animate-bounce backdrop-blur-sm text-[16px]  text-white hover:text-gray-700 flex items-center rounded-md py-1 px-2 border-2
                     border-solid border-white bg-transparent hover:bg-white font-normal">
                            {mainBanner?.mainBannerCtaText} &#8592;
                        </button>
                    </a>
                </div>}
            </div>
        </div>
    </>
}